import { createContext, useContext } from "react";
import io from "socket.io-client";
import {
  FancySocketUrl,
  GlobalWebSocket,
  socketServerUrl,
  BookMakerSocketUrl,
} from "../utils/constance";

const socketOptions = {
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax: 1000,
  reconnectionAttempts: Infinity,
  transports: [
    "websocket",
    "flashsocket",
    "htmlfile",
    "xhr-polling",
    "jsonp-polling",
    "polling",
  ],
};

const socketServerOptions = {
  autoConnect: true,
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax: 1000,
  reconnectionAttempts: Infinity,
  transports: [
    "websocket",
    "flashsocket",
    "htmlfile",
    "xhr-polling",
    "jsonp-polling",
    "polling",
  ],
};

let fancySocketURL = FancySocketUrl;
let GLOBAL_WS_BASE = GlobalWebSocket;
// let socketServer = socketServerUrl;

export const FancySocket = io(fancySocketURL, socketOptions);
export const BookmakerSocket = io(BookMakerSocketUrl, socketOptions);

// export const serverSocket = io(socketServer, {
//   autoConnect: true,
//   reconnection: true,
//   reconnectionDelay: 500,
//   reconnectionDelayMax: 1000,
//   reconnectionAttempts: Infinity,
//   transports: ["websocket", "polling", "flashsocket"],
// });

export const _socket = io(GLOBAL_WS_BASE, {
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax: 1000,
  reconnectionAttempts: Infinity,
  transports: ["websocket", "polling", "flashsocket"],
});

export const socketContext = createContext();

export const SocketProvider = socketContext.Provider;

export default function useSocketContext() {
  return useContext(socketContext);
}
